import { Component, EventEmitter, Input, Output } from '@angular/core';
import { FileUtils } from "../../ui-utils/file-utils";
import { FileData } from "../../ui-dto/file/file-data";
import { TypeUpload } from "../../ui-dto/upload/type-upload";
var CSS_STYLE = ":root{ --secondary-button-text-color: #354052; }";
var HTML_TEMPLATE = "\n<od-button *ngIf=\" type === 'button'\" [text]=\"text == null?'':text\" (click)=\"inputFile.click()\"\n[iconName]=\"iconName\" [disabled]=\"disabled\" [size]=\"size\" type=\"button\" ></od-button>\n<od-icon-link *ngIf=\" type === 'iconLink'\" [text]=\"text == null?'':text\" [clickable]=\"true\" (click)=\"inputFile.click()\"\n[iconName]=\"iconName\" [disabled]=\"disabled\" [size]=\"size\" [color]=\"'var(--secondary-button-text-color)'\"></od-icon-link>\n<input #inputFile type=\"file\" hidden (change)=\"onChange($event)\" [disabled]=\"disabled\"\n [attr.multiple]=\"multiple == true ? true : null\"/>\n";
var Upload = /** @class */ (function () {
    function Upload() {
        this.change = new EventEmitter();
        this.text = "";
        this.disabled = false;
        this.iconName = "odi_attach";
        this.size = "180px";
        this.multiple = false;
        this.type = TypeUpload.BUTTON;
    }
    Object.defineProperty(Upload.prototype, "filesData", {
        get: function () {
            return this._filesData;
        },
        enumerable: true,
        configurable: true
    });
    Upload.prototype.onChange = function (e) {
        var input = e.currentTarget;
        if (input.value != null) {
            this.clean();
            var _loop_1 = function () {
                var reader = new FileReader();
                var data = input.files[i];
                var fileData = new FileData();
                fileData.name = data.name;
                if (!FileUtils.isImage(data.type))
                    fileData.icon = FileUtils.getFileIcon(data.name);
                fileData.lastModifiedDate = data.lastModified;
                reader.onload = function (e) {
                    fileData.data = reader.result;
                };
                reader.readAsDataURL(data);
                this_1._filesData.push(fileData);
            };
            var this_1 = this;
            for (var i = 0; input.files.length > i; i++) {
                _loop_1();
            }
            this.change.emit(this._filesData);
        }
    };
    Upload.prototype.clean = function () {
        this._filesData = [];
    };
    Upload.decorators = [
        { type: Component, args: [{
                    selector: 'od-upload',
                    template: HTML_TEMPLATE,
                    styles: [CSS_STYLE]
                },] },
    ];
    /** @nocollapse */
    Upload.ctorParameters = function () { return []; };
    Upload.propDecorators = {
        "text": [{ type: Input },],
        "iconName": [{ type: Input },],
        "disabled": [{ type: Input },],
        "size": [{ type: Input },],
        "multiple": [{ type: Input },],
        "type": [{ type: Input },],
        "change": [{ type: Output },],
    };
    return Upload;
}());
export { Upload };
//# sourceMappingURL=upload.js.map


//////////////////
// WEBPACK FOOTER
// /home/qa/builder/ui-ts/dist/ui-components/upload/upload.js
// module id = 427
// module chunks = 14